import type { DesignTokens, ThemeRow } from "../types/theme";

/**
 * Maps logical DesignTokens to their respective database column base names.
 */
export const TOKEN_MAP: Record<keyof DesignTokens, keyof ThemeRow | null> = {
  background: "background",
  foreground: "foreground",
  surface: "surface",
  mutedForeground: "muted_foreground",
  accent: "accent",
  accentForeground: "accent_foreground",
  danger: "danger",
  warning: "warning",
  success: "success",
  patternType: "pattern_type",
  patternOpacity: "pattern_opacity",

  // --- Hero UI Mappings ---
  fontNormal: "font_normal",
  fontMedium: "font_medium",
  fontSemiBold: "font_semibold",
  fontBold: "font_bold",
  radius: "radius",
  surfaceForeground: "surface_foreground",
  surfaceSecondary: "surface_secondary",
  surfaceSecondaryForeground: "surface_secondary_foreground",
  surfaceTertiary: "surface_tertiary",
  surfaceTertiaryForeground: "surface_tertiary_foreground",
  overlay: "overlay",
  overlayForeground: "overlay_foreground",
  default: null,
  defaultForeground: "default_foreground",
  fieldForeground: null,
  fieldPlaceholder: null,
  fieldBorder: null,
  fieldBackground: "field_background",
  dangerForeground: null,
  successForeground: null,
  warningForeground: null,
  segment: "segment",
  segmentForeground: "segment_foreground",
  border: "border",
  separator: "divider", // Database column is still 'divider'
  focus: "focus",
  link: "link",
  glassBackground: "glass_background",
  glassBorder: "glass_border",
  glassHighlight: "glass_highlight",
  surfaceShadow: "surface_shadow",
  overlayShadow: "overlay_shadow",
  fieldShadow: "field_shadow",

  // Other tokens not mapped to columns
  muted: null,
  backdrop: null,
  primary: null,
  primaryForeground: null,
  secondary: null,
  secondaryForeground: null,
  glow0: null,
  glow1: null,
  glow2: null,
  // Bible reading tokens: no dedicated column in `themes`;
  // ALWAYS resolved from base tokens of effective variant, so
  // that any theme (default or custom) receives the matching
  // claro/oscuro con contraste garantizado.
  strong: null,
  redLetter: null,
};

/**
 * Maps logical DesignTokens to their respective database column pair names.
 */
export const PAIR_TOKEN_MAP: Record<keyof DesignTokens, keyof ThemeRow | null> = {
  background: "p_background",
  foreground: "p_foreground",
  surface: "p_surface",
  mutedForeground: "p_muted_foreground",
  accent: "p_accent",
  accentForeground: "p_accent_foreground",
  danger: "p_danger",
  warning: "p_warning",
  success: "p_success",
  patternType: "p_pattern_type",
  patternOpacity: "p_pattern_opacity",

  // --- Hero UI Mappings ---
  fontNormal: "p_font_normal",
  fontMedium: "p_font_medium",
  fontSemiBold: "p_font_semibold",
  fontBold: "p_font_bold",
  radius: "p_radius",
  surfaceForeground: "p_surface_foreground",
  surfaceSecondary: "p_surface_secondary",
  surfaceSecondaryForeground: "p_surface_secondary_foreground",
  surfaceTertiary: "p_surface_tertiary",
  surfaceTertiaryForeground: "p_surface_tertiary_foreground",
  overlay: "p_overlay",
  overlayForeground: "p_overlay_foreground",
  default: null,
  defaultForeground: "p_default_foreground",
  fieldForeground: null,
  fieldPlaceholder: null,
  fieldBorder: null,
  fieldBackground: "p_field_background",
  dangerForeground: null,
  successForeground: null,
  warningForeground: null,
  segment: "p_segment",
  segmentForeground: "p_segment_foreground",
  border: "p_border",
  separator: "p_divider",
  focus: "p_focus",
  link: "p_link",
  glassBackground: "p_glass_background",
  glassBorder: "p_glass_border",
  glassHighlight: "p_glass_highlight",
  surfaceShadow: "p_surface_shadow",
  overlayShadow: "p_overlay_shadow",
  fieldShadow: "p_field_shadow",

  // Other tokens not mapped to columns
  muted: null,
  backdrop: null,
  primary: null,
  primaryForeground: null,
  secondary: null,
  secondaryForeground: null,
  glow0: null,
  glow1: null,
  glow2: null,
  strong: null,
  redLetter: null,
};
